import { showErrorSnackbar, showSuccessSnacbar } from '@components/shared-layouts/Snackbar/helper'
import { CustomSubmitButton } from '@components/shared-ui-components/Buttons'
import { CustomNumberField, CustomTextField } from '@components/shared-ui-components/CustomFields'
import CustomClarifierStrategyField from '@components/shared-ui-components/CustomFields/Clarifier/ClarifierPage/CustomClarifierStrategyField'
import OperationSuccessfullyCompletedModal from '@components/shared-ui-components/DynamicForm/OperationSuccessfullyCompletedModal'
import ProgressbarModal from '@components/shared-ui-components/DynamicForm/ProgressbarModal'
import { getDynamicFormValidationSchema } from '@components/shared-ui-components/DynamicForm/helper'
import ProjectContext from '@context/Project/projectContext'
import { Paper } from '@mui/material'
import { startTieredHardnessRound } from '@services/dashboardService'
import { getProjectType } from '@utils/index'
import { FormikHelpers, useFormik } from 'formik'
import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

const initialDefaultValues = {
  base_model: 'srikeshram/GENIE-2D-CLARIFIER/run_v2gar86z_model:v1',
  hard_strategy: undefined,
  medium_strategy: undefined,
  easy_strategy: undefined,
  ct_budget: 10,
  easy_budget_ratio: 0.4,
  med_budget_ratio: 0.3,
  hard_budget_ratio: 0.3,
}

function TieredHardnessPage() {
  
  const page = 'tieredHardness'
  
  const { projectId, project_type } = useParams();
  
  const projectType = getProjectType()
  
  const [operationSuccessModal, setOperationSuccessModal] = useState<boolean>(false);

  const [checkLiveStatusModal, setCheckLiveStatusModal] = useState<boolean>(false);
  
  const projectContextInfo = useContext(ProjectContext);
  const { state: projectState, setState: setProjectState } = projectContextInfo;
  
  const handleSubmit = (values: any, actions: FormikHelpers<any>) => {
    
    console.log('handle submit is running')

    console.log("submit Values ====>", values);
    values["project_id"] = projectId;
    values['project_type'] = project_type
    // Over here we will get api function to be call
    startTieredHardnessRound(values)
      .then((x: any) => {
        console.log("Response from api", x);
        // Reset the form after success
        actions.resetForm();
        // Enable the form
        actions.setSubmitting(false);
        // Set ProjectContext 
        setProjectState({
          ...projectState,
          processId: x.data?.process_id || x.process_id,
        });
        // show a notification progress has been save
        showSuccessSnacbar(x.data?.message || x.message || 'Operation started successfully');
        // Show Success Modal
        setOperationSuccessModal(true);
      })
      .catch((e: any) => {
        // Over here we need to handle the status codes ===>
        console.log("THis is the error coming", e);
        // showErrorSnackbar
        if (e.status === 400) {
          showErrorSnackbar(e.error.message);
        }
        actions.setSubmitting(false);
      });
  };
  
  const formik = useFormik({
    initialValues: initialDefaultValues,
    enableReinitialize: true, 
    validationSchema: getDynamicFormValidationSchema(page, projectType),
    onSubmit: handleSubmit,
  });

  const {
    handleSubmit: handleSub,
    isSubmitting,
    errors,
    values,
    touched,
    handleChange,
  } = formik || {};
  
  console.log('formik error ===>', formik.errors, isSubmitting)

  const handleOperationModalClose = () => {
    setOperationSuccessModal(false);
  };

  const handleCheckLiveStatusModalClose = () => {
    setCheckLiveStatusModal(false);
  };

  const handleCheckLiveStatus = () => {
    // First we close the operation successful Modal
    setOperationSuccessModal(false);
    setCheckLiveStatusModal(true);
  };

  
  console.log('valuessss----', values, errors)
  
  return (
    <Paper
      elevation={3} // Add shadow effect
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '0px'
      }}
    >
      <h4>Please fill up the Tiered Hardness form</h4>
     <form onSubmit={handleSub} style={{ display: "inline-grid" }}>
        
        <CustomTextField
          label={'Base Model'}
          name={'base_model'}
          value={values['base_model']}
          onChange={handleChange}
          error={Boolean(touched['base_model'] && errors['base_model'])}
          helperText={touched['base_model'] && errors['base_model'] ? String(errors['base_model']) : ''}
          sx={{ mb: 2 }}
          disabled={isSubmitting}
        />
        
        <CustomClarifierStrategyField
          label={'Hard Strategy'}
          name={'hard_strategy'}
          value={values.hard_strategy}
          onChange={handleChange}
          error={Boolean(touched['hard_strategy'] && errors['hard_strategy'])}
          sx={{ mb: 2 }}
          disabled={isSubmitting}
          formik={formik}
        />
        
        <CustomClarifierStrategyField
          label={'Medium Strategy'}
          name={'medium_strategy'}
          value={values['medium_strategy']}
          onChange={handleChange}
          error={Boolean(touched['medium_strategy'] && errors['medium_strategy'])}
          sx={{ mb: 2 }}
          disabled={isSubmitting}
          formik={formik}
        />
        
        <CustomClarifierStrategyField
          label={'Easy Strategy'}
          name={'easy_strategy'}
          value={values['easy_strategy']}
          onChange={handleChange}
          error={Boolean(touched['easy_strategy'] && errors['easy_strategy'])}
          sx={{ mb: 2 }}
          disabled={isSubmitting}
          formik={formik}
        />

        <CustomNumberField
          label={'CT Budget'}
          name={'ct_budget'}
          value={values['ct_budget']}
          onChange={handleChange}
          error={Boolean(touched['ct_budget'] && errors['ct_budget'])}
          helperText={touched['ct_budget'] && errors['ct_budget'] ? String(errors['ct_budget']) : ''}
          sx={{ mb: 2 }}
          InputProps={{ inputProps: { min: 1} }}
          disabled={isSubmitting}
        />
        
        <CustomNumberField
          label={'Easy Budget Ratio'}
          name={'easy_budget_ratio'}
          value={values['easy_budget_ratio']}
          onChange={handleChange}
          error={Boolean(touched['easy_budget_ratio'] && errors['easy_budget_ratio'])}
          helperText={touched['easy_budget_ratio'] && errors['easy_budget_ratio'] ? String(errors['easy_budget_ratio']) : ''}
          sx={{ mb: 2 }}
          InputProps={{ inputProps: { min: 0, max: 1, step: 0.01} }}
          disabled={isSubmitting}
        />
        
        <CustomNumberField
          label={'Medium Budget Ratio'}
          name={'med_budget_ratio'}
          value={values['med_budget_ratio']}
          onChange={handleChange}
          error={Boolean(touched['med_budget_ratio'] && errors['med_budget_ratio'])}
          helperText={touched['med_budget_ratio'] && errors['med_budget_ratio'] ? String(errors['med_budget_ratio']) : ''}
          sx={{ mb: 2 }}
          InputProps={{ inputProps: { min: 0, max: 1, step: 0.01} }}
          disabled={isSubmitting}
        />
        
        <CustomNumberField
          label={'Hard Budget Ratio'}
          name={'hard_budget_ratio'}
          value={values['hard_budget_ratio']}
          onChange={handleChange}
          error={Boolean(touched['hard_budget_ratio'] && errors['hard_budget_ratio'])}
          helperText={touched['hard_budget_ratio'] && errors['hard_budget_ratio'] ? String(errors['hard_budget_ratio']) : ''}
          sx={{ mb: 2 }}
          InputProps={{ inputProps: { min: 0, max: 1, step: 0.01} }}
          disabled={isSubmitting}
        />
        
        <CustomSubmitButton btnName="Submit" isSubmitting={isSubmitting} />
      
      </form>
      
      {/* Dialog for showing the Operation Successful Modal */}
      <OperationSuccessfullyCompletedModal
          open={operationSuccessModal}
          close={handleOperationModalClose}
          handleCheckLiveStatus={handleCheckLiveStatus}
        />
        {/* Dialog for Showing the Check Live status  */}
        {checkLiveStatusModal && (
          <ProgressbarModal
            page={page}
            open={checkLiveStatusModal}
            close={handleCheckLiveStatusModalClose}
          />
        )}
      
      
    </Paper>
  )
}

export default TieredHardnessPage

